import {required} from "vuelidate/lib/validators";  

const AnktAnket = {
    data() {
      return { 
        AnktAnketData:{ 
          CreatedBy: "a",
          Created: "",
          LastModifiedBy: "b",
          LastModified: "",
          Baslik: "",
          Aciklama: "",
          Anketkapalimi: true,
          Anketkapalimesaji: "",
          Ertele: false,
          Yanitlamakistemiyorum: false,
          Disanketurl: "",
          Yetkilipersonelids: [],
          Kimlercevaplayabilir: [], 
          Birimids: [], 
          Uygulamaids: [], 
          Anketjson: "",
          Ipkontrol: false, 
          Baslamatarihi: "",
          Bitistarihi: "",
          Filename: "",
          BackgroundColor:"",
          Birimid:null,
          Testkullanim:false,
          Disuygulamaadi:null
        },  
          FormDataType:{
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:this.$t('AnktAnket.AddEdit.Baslik'),FieldType:"text"},
            Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle:this.$t('AnktAnket.AddEdit.Aciklama'),FieldType:"text"},
            Yetkilipersonelids:{FieldName:"Yetkilipersonelids",Field:"combobox",FieldTitle:this.$t('AnktAnket.AddEdit.Yetkilipersonelids'),ComboDataArray:[]},
            Kimlercevaplayabilir:{FieldName:"Kimlercevaplayabilir",Field:"combobox",FieldTitle:this.$t('AnktAnket.AddEdit.Kimlercevaplayabilir'),ComboDataArray:[]},
            Birimids:{FieldName:"Birimids",Field:"combobox",FieldTitle:this.$t('AnktAnket.AddEdit.Birimids'),ComboDataArray:[]},
            Yanitlamakistemiyorum:{FieldName:"Yanitlamakistemiyorum",Field:"checkbox",FieldTitle:this.$t('AnktAnket.AddEdit.Yanitlamakistemiyorum')},
            Ertele:{FieldName:"Ertele",Field:"input",FieldTitle:this.$t('AnktAnket.AddEdit.Ertele')},
            Disanketurl:{FieldName:"Disanketurl",Field:"input",FieldTitle:this.$t('AnktAnket.AddEdit.Disanketurl'),FieldType:"text"},
            Anketkapalimi:{FieldName:"Anketkapalimi",Field:"input",FieldTitle:this.$t('AnktAnket.AddEdit.Anketkapalimi'),FieldType:"text",Disabled:false},
            Anketkapalimesaji:{FieldName:"Anketkapalimesaji",Field:"input",FieldTitle:this.$t('AnktAnket.AddEdit.Anketkapalimesaji'),FieldType:"text"},   
            Ipkontrol:{FieldName:"Ipkontrol",Field:"checkbox",FieldTitle:this.$t('AnktAnket.AddEdit.Ipkontrol')},
            Uygulamaids:{FieldName:"Uygulamaids",Field:"combobox",FieldTitle:this.$t('AnktAnket.AddEdit.Uygulamaids'),ComboDataArray:[]},
            Baslamatarihi:{FieldName:"Baslamatarihi",Field:"date",FieldTitle:this.$t('AnktAnket.AddEdit.Baslamatarihi')},
            Bitistarihi:{FieldName:"Bitistarihi",Field:"date",FieldTitle:this.$t('AnktAnket.AddEdit.Bitistarihi')},
            Filename:{FieldName:"Filename",Field:"file",FieldTitle:this.$t('AnktAnket.AddEdit.Filename')},
            BackgroundColor:{FieldName:"BackgroundColor",Field:"text",FieldTitle:this.$t('AnktAnket.AddEdit.BackgroundColor'),FieldType:"color"},
            Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:this.$t('AnktAnket.AddEdit.Birimid'),ComboDataArray:[]},
            Testkullanim:{FieldName:"Testkullanim",Field:"checkbox",FieldTitle:this.$t('AnktAnket.AddEdit.Testkullanim')},
          }  
      } 
    },
    validations:{ 
      FormData: {
          Baslik: { required },  
          Aciklama: {  },  
          Yetkilipersonelids: {  required }, 
          Kimlercevaplayabilir: {   },  
          Birimids: {   },  
          Yanitlamakistemiyorum: {  },  
          Ertele: {  },  
          Disanketurl: {  },  
          Anketkapalimi: {  },  
          Anketkapalimesaji: {  },  
          Ipkontrol: {  }, 
          Uygulamaids: {   }, 
          Baslamatarihi: { required }, 
          Bitistarihi: {  }, 
          Filename: {  }, 
          BackgroundColor: {  },   
          Birimid: {  required },  
          Testkullanim: {  },   
      } 
  },
  created(){ 
    let Page= { 
      PageNumber: "1",
      PageSize: "9999"
    }
        this.ActionsGet({"Service":"pbsunvantip","Page":Page}).then(res => {  
      this.FormDataType.Kimlercevaplayabilir.ComboDataArray.push ( {
        id: '',
        label: 'Tümünü Seç',
        children: [  ],
      });
      for(var i=0; i<res.Data.length; i++)
        { 
          this.FormDataType.Kimlercevaplayabilir.ComboDataArray[0].children.push ({id:res.Data[i].Id,label:res.Data[i].UnvanTipAdi})       
        }    
    }); 

   /* this.ActionsGet({"Service":this.$config.API_ACCOUNT_URL+"Account/get-users","Page":Page}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        { 
          this.FormDataType.Yetkilipersonelids.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].FirstName+ " "+ res.Data[i].LastName})       
        }    
    }); */

        this.ActionsFilterGet({
          Service:this.$config.API_ACCOUNT_URL+"Account/get-users-in-roles",
          Page: Page,
          Filter: "&roles=['AnketKullanici','AnketAdmin','AnketTumAnketler','AnketOnay','AnketBirimAnketler']"
        }).then((res) => {
          this.FormDataType.Yetkilipersonelids.ComboDataArray.push ( {
            id: '',
            label: 'Tümünü Seç',
            children: [  ],
          });
          for(var i=0; i<res.Data.length; i++)
            { 
              this.FormDataType.Yetkilipersonelids.ComboDataArray[0].children.push ({id:res.Data[i].Id,label:res.Data[i].FirstName + " " + res.Data[i].LastName})       
            }    
    });

  
    this.ActionsGet({"Service":"OUygulama","Page":Page}).then(res => {  
      this.FormDataType.Uygulamaids.ComboDataArray.push ( {
        id: '',
        label: 'Tümünü Seç',
        children: [  ],
      });
      for(var i=0; i<res.Data.length; i++)
        { 
          this.FormDataType.Uygulamaids.ComboDataArray[0].children.push ({id:res.Data[i].Id,label:res.Data[i].Uygulamaadi})       
        }    
    }); 

    this.ActionsGet({"Service":"OBirim/GetTreeByAnaBirim","Page":Page}).then(res => { 
      
      let tumu = [];
      tumu.push({ id: 1, label: "Tümü", children: null });
      let gelen_veri = JSON.stringify(res.Data); 
      let silinecek = '"children":null,';
      gelen_veri = gelen_veri.replaceAll(silinecek, ""); 
      tumu[0].children = JSON.parse(gelen_veri);
      this.FormDataType.Birimids.ComboDataArray = tumu;   
     
    }); 

    let Page2 = {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1",
    }
  this.Userid = this.TokenUserId;
    
    let Filter = "&Kisaadi=ANKT&Ouygulamakod=461";

    this.ActionsFilterGet({Service: "Ouygulama",  Page:Page2,Filter:Filter}).then((res) => {
      if(res){

      if (this.Userid != null && res.Data[0].Id != null) {

     Filter += "&Userid=" + this.Userid +"&Uygulamaid="+res.Data[0].Id;

  

            this.ActionsFilterGet({Service:"OBirim/GetTreeByAnaBirim", "Page":Page2, Filter:Filter}).then((res) => {
                let tumu = [];
                tumu.push({ id: 1, label: "Tümü", children: null });
                let gelen_veri=JSON.stringify(res.Data);

                let silinecek='"children":null,'
                gelen_veri=gelen_veri.replaceAll(silinecek,"");

  

                tumu[0].children = JSON.parse(gelen_veri);
                this.FormDataType.Birimid.ComboDataArray = tumu;    


            });                                                         

      } else {

            this.ActionsGet({"Service":"OBirim/GetTreeByAnaBirim", "Page":Page2}).then((res) => {
                let tumu = [];
                tumu.push({ id: 1, label: "Tümü", children: null });
                let gelen_veri=JSON.stringify(res.Data);

                let silinecek='"children":null,'
                gelen_veri=gelen_veri.replaceAll(silinecek,"");

                tumu[0].children = JSON.parse(gelen_veri);
                this.FormDataType.Birimid.ComboDataArray = tumu;    

            });
      
      }

      }
    });

  }
}
export default AnktAnket